import { AnimatePresence } from 'framer-motion';
import { useEffect, useRef, useState } from 'react';
import Confetti from 'react-confetti';
import { useNavigate } from 'react-router-dom';
import { HighFiveButton } from '../../shared/components/HighFiveButton';
import { OllieFloating } from '../../shared/components/OllieFloating';
import { SpeechBubble } from '../../shared/components/SpeechBubble';
import { useRevenueCat } from '../../shared/hooks/useRevenueCat';
import { ROUTES } from '../../shared/routing/routes';
import { useOnboardingStore } from './hooks/useOnboardingStore';

export const HighFive = () => {
    const navigate = useNavigate();
    const [disableButton, setDisableButton] = useState(true);
    const [confetti, setConfetti] = useState(false);
    const [ollieText, setOllieText] = useState("Great! You're halfway there. Just a couple more steps to complete.");
    const showAskForReviewRef = useRef(true);
    const [showHighFive, setShowHighFive] = useState(true);
    const referralCode = useOnboardingStore(state => state.referralCode);
    const { setCustomerAttributes } = useRevenueCat();

    // Fetch onboarding_show_ask_for_review flag from Firestore
    useEffect(() => {
        const saveReferralCodeToCustomAttributes = async () => {
            if (referralCode) {
                await setCustomerAttributes({ referralCode: referralCode });
            }
        };
        saveReferralCodeToCustomAttributes();
    }, []);

    const handleHighFive = () => {
        setDisableButton(true);
        setOllieText("Nice! Here's a little confetti to keep you going!");

        setConfetti(true);
        setShowHighFive(false);

        // Auto-navigate after 2 seconds
        setTimeout(() => {
            if (showAskForReviewRef.current) {
                navigate(ROUTES.onboarding.rating);
            } else {
                navigate(ROUTES.onboarding.ocdCycleIntro);
            }
        }, 2500);
    };

    const handleSpeechBubbleComplete = () => {
        setDisableButton(false);
    };

    return (
        <div className='flex flex-col gap-10 safe-pb-4 px-8 flex-1 overflow-hidden relative'>
            <title>High Five</title>
            {confetti && (
                <div className="absolute inset-0 z-0 pointer-events-none">
                    <Confetti
                        confettiSource={{
                            x: 0,
                            y: window.innerHeight + 10,
                            w: window.innerWidth,
                            h: 10
                        }}
                        initialVelocityX={5}
                        initialVelocityY={80}
                        gravity={.95}
                        numberOfPieces={200}
                        recycle={false}
                        tweenDuration={160}
                    />
                </div>
            )}
            <div className='flex-1 flex flex-col justify-center items-center relative z-10'>
                <div className='flex flex-col items-center justify-end overflow-show h-[250px]'>
                    <SpeechBubble text={ollieText} onTypingComplete={handleSpeechBubbleComplete} />
                    <OllieFloating />
                </div>
            </div>
            <div className="flex flex-col items-center justify-end gap-4 flex-shrink-0 relative z-10 min-h-[260px]">
                <AnimatePresence mode="wait">
                    {showHighFive && (
                        <HighFiveButton
                            disableButton={disableButton}
                            emoji="✋"
                            title="Give me Five! You're doing great!"
                            handleHighFive={handleHighFive} />
                    )}
                </AnimatePresence>
            </div>
        </div>
    );
};